import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatErr = (detail) => {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return detail?.msg || String(detail);
};

export const adminApi = () =>
  axios.create({ baseURL: API, headers: { Authorization: `Bearer ${sessionStorage.getItem("rt_admin") || ""}` } });
